<template>
  <div class="row">
    <div class="col-md-8">
      <grab-chart :chart-data="chartData"/>
    </div>
    <div class="col-md-4">
      <el-table :data="activeProcess.statsServer" highlight-current-row ref="grabJobServersTable" height="310" @current-change="changeCurrentServer">
        <el-table-column label="Server" width="150">
          <template slot-scope="scope">
            <strong>{{ getServerHostname(scope.row.server_id) }}</strong>
          </template>
        </el-table-column>
        <el-table-column align="left">
          <template slot-scope="scope">
            <div v-if="progressBars">
              <div class="text-left" v-if="scope.row.grabTotal">
                <strong>Grabbing</strong>
                <small>({{ scope.row.grabCount }} / {{ scope.row.grabTotal }})</small>
                <div class="progress">
                  <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-info" :style="{width: getPercent(scope.row.grabCount, scope.row.grabTotal)+'%'}"></div>
                </div>
              </div>
              <div class="text-left" v-if="scope.row.mdbTotal">
                <strong>Postprocessing</strong>
                <small>({{ scope.row.mdbCount }} / {{ scope.row.mdbTotal }})</small>
                <div class="progress">
                  <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-success" :style="{width: getPercent(scope.row.mdbCount, scope.row.mdbTotal)+'%'}"></div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import GrabChart from "./CurrentJob/GrabChart";

export default {
  props: {
    activeProcess: Object,
    progressBars: {
      type: Boolean,
      default: true
    }
  },
  components: {GrabChart},
  async mounted () {
    await this.serverFetchList();

    if (!this.currentServerId && this.activeProcess.statsServer) {
      const row = this.activeProcess.statsServer[0];
      this.$refs.grabJobServersTable.setCurrentRow(row);
      this.generateChartData();
    }
  },
  watch: {
    activeProcess: {
      handler (data) {
        if (!this.currentServerId && data.statsServer) {
          const row = data.statsServer[0];
          this.$refs.grabJobServersTable.setCurrentRow(row);
          // this.currentServerId = serverId;
          this.generateChartData();
        }
      },
      deep: true
    }
  },
  computed: {
    // ...mapGetters(['activeProcess']),
  },
  data: function () {
    return {
      currentServerId: null,
      chartData: {
        series: [],
        labels: []
      }
    }
  },
  methods: {
    ...mapActions(['serverFetchList']),
    ...mapGetters(['serverById']),
    getServerHostname: function (id) {
      const server = this.serverById()(id);
      if (server && server.hostname) {
        return server.hostname;
      }
      return '';
    },
    changeCurrentServer: function (row) {
      if (row && row.server_id) {
        this.currentServerId = row.server_id;
      } else {
        this.currentServerId = null;
      }
      this.generateChartData();
    },
    generateChartData: function () {
      const process = this.activeProcess;
      const serverId = this.currentServerId;
      let labels = [];
      let data = [];
      if (serverId && process && process.statsServer) {
        let serverStats = process.statsServer.find(serverStat => serverStat.server_id === serverId);
        if (serverStats) {
          let serverData = [], mdbData = [];
          if (serverStats.entries) {
            serverStats.entries.forEach(function (serverStat) {
              serverData.push(serverStat['grabCount']);
              // serverData.push(Math.random()*100);
              mdbData.push(serverStat['mdbCount']);
              labels.push(serverStat['reported_at']);
            });
          }
          data.push(serverData);
          data.push(mdbData);
        }
      }
      this.chartData = {series: data, labels: labels};
      return this.chartData;
    },
    getPercent: function (count, total) {
      let result = 0;
      if (total > 0) {
        result = Math.round((count / total) * 100);
      }
      return result;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GrabProcess/List/CurrentJob.vue